// 双方截图 on the round steps 「推荐后 24 小时说明电话」「见面前交叉电话（双方）」
// 「约会后 24–48 小时双向反馈」: two upload slots per recommended pair of the round —
// 本会员 and 对方. The step's 标记完成 is only offered (and accepted by the backend)
// once both slots of at least one pair have a screenshot.
// Screenshots already attached to the matching 联系记录 (推荐说明 / 见面前 / 见面后,
// items with from_contact) are listed too and count, so they aren't uploaded twice.
// Uploads go through the same /upload endpoint as the 打卡 screenshots, then
// POST /profiles/:id/step-attachments. Before that API is deployed the list
// call fails and this block is not shown at all.
import React, { useRef, useState } from 'react';
import { Plus, X } from 'lucide-react';
import { toast } from 'react-toastify';
import { coachDailyContactsAPI, stepExtrasAPI } from '../../../services/api';
import { resolvePhotoUrl } from '../../../utils/photoUtils';
import { S, stepDef } from './wsShared';
import { QrUploadButton } from './QrUpload';

export const SHOT_STEP_KEYS = ['rec_call', 'cross_call', 'date_feedback'];

export default function StepShots({ profileId, stepKey, pairs = [], items = [], memberName = '', meId, isSup, isZh = true, disabled = false, onItems }) {
  const t = (zh, en) => (isZh ? zh : en);
  const [busy, setBusy] = useState(null); // `${matchId}:${party}` while uploading
  const fileRef = useRef(null);
  const target = useRef(null);

  const of = (matchId, party) => items.filter((x) => Number(x.match_id) === Number(matchId) && x.step_key === stepKey && x.party === party);

  const pick = (matchId, party) => {
    target.current = { matchId, party };
    if (fileRef.current) fileRef.current.click();
  };
  const onFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    const tg = target.current;
    if (fileRef.current) fileRef.current.value = '';
    if (!files.length || !tg) return;
    setBusy(`${tg.matchId}:${tg.party}`);
    try {
      const urls = [];
      for (const f of files.slice(0, 9)) {
        const r = await coachDailyContactsAPI.uploadImage(f);
        const u = r.data?.url || r.data?.file_url;
        if (u) urls.push(u);
      }
      if (!urls.length) throw new Error('no url');
      const r = await stepExtrasAPI.addAttachments(profileId, { match_id: tg.matchId, step_key: stepKey, party: tg.party, urls });
      onItems && onItems(r.data?.items || [], true);
      toast.success(t('截图已上传', 'Uploaded'));
    } catch (err) {
      toast.error(err?.response?.data?.error || t('截图上传失败', 'Upload failed'));
    } finally { setBusy(null); }
  };
  // Phone uploads (扫码上传) are written server-side; re-read the list when the dialog sees new ones.
  const refresh = async () => {
    try {
      const r = await stepExtrasAPI.attachments(profileId);
      onItems && onItems(Array.isArray(r.data?.items) ? r.data.items : [], true);
    } catch (err) { /* next poll retries */ }
  };
  const remove = async (x) => {
    // eslint-disable-next-line no-alert
    if (!window.confirm(t('删除这张截图？', 'Delete this screenshot?'))) return;
    try {
      const r = await stepExtrasAPI.removeAttachment(x.id);
      onItems && onItems(r.data?.items || [], true);
    } catch (err) {
      toast.error(err?.response?.data?.error || t('删除失败', 'Delete failed'));
    }
  };

  const slot = (m, party) => {
    const list = of(m.id, party);
    const who = party === 'self'
      ? t(`本会员 · ${memberName || '—'}`, `Member · ${memberName || '—'}`)
      : t(`对方 · ${m.other_name || '—'}`, `Other side · ${m.other_name || '—'}`);
    const loading = busy === `${m.id}:${party}`;
    return (
      <div key={party} style={{ border: `1px solid ${S.line}`, background: '#F6F3EE', borderRadius: 2, padding: 10, display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', minWidth: 0 }}>
        {list.map((x) => (
          <div key={x.id} style={{ position: 'relative', width: 56, height: 56, flex: 'none' }}
            title={x.from_contact ? t('来自联系记录的截图（在联系记录里修改或删除）', 'From the contact record (edit it there)') : undefined}>
            <a href={resolvePhotoUrl(x.url) || x.url} target="_blank" rel="noreferrer">
              <img src={resolvePhotoUrl(x.url) || x.url} alt="" style={{ width: 56, height: 56, objectFit: 'cover', borderRadius: 2, border: `1px solid ${S.line}`, display: 'block' }} />
            </a>
            {x.from_contact && (
              <span style={{ position: 'absolute', left: 0, right: 0, bottom: 0, textAlign: 'center', fontSize: 9.5, letterSpacing: '.12em', lineHeight: '15px',
                background: 'rgba(255,253,249,.92)', color: S.ink, pointerEvents: 'none' }}>{t('记录', 'LOG')}</span>
            )}
            {!disabled && !x.from_contact && (isSup || Number(x.uploaded_by) === Number(meId)) && (
              <button type="button" aria-label={t('删除截图', 'Delete')} onClick={() => remove(x)}
                style={{ position: 'absolute', top: 2, right: 2, width: 16, height: 16, borderRadius: '50%', border: 'none', background: 'rgba(0,0,0,.6)', color: '#FFFDF9', padding: 0, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <X size={10} />
              </button>
            )}
          </div>
        ))}
        {!disabled && list.length < 9 && (
          <button type="button" disabled={!!busy} onClick={() => pick(m.id, party)} aria-label={t(`上传${party === 'self' ? '本会员' : '对方'}截图`, 'Upload')}
            style={{ width: 56, height: 56, flex: 'none', border: `1px dashed ${list.length ? 'rgba(17,17,17,.25)' : '#9E2B25'}`, background: '#FFFDF9', borderRadius: 2,
              color: list.length ? S.sub : '#9E2B25', fontFamily: 'inherit', fontSize: 12, cursor: busy ? 'wait' : 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
            {loading ? '…' : <><Plus size={14} />{t('上传', 'Add')}</>}
          </button>
        )}
        {!disabled && list.length < 9 && (
          <QrUploadButton profileId={profileId} isZh={isZh} variant="tile" tileW={56} tileH={56} style={{ fontSize: 10.5, gap: 2 }}
            target={{ kind: 'step', match_id: m.id, step_key: stepKey, party }}
            where={`${party === 'self' ? (memberName || '—') : (m.other_name || '—')} · ${(stepDef(stepKey) || {}).name || ''} · ${party === 'self' ? t('本会员截图', 'member side') : t('对方截图', 'other side')}`}
            onChanged={refresh} />
        )}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 3, minWidth: 0, fontSize: 13, color: S.ink }}>
          <span style={{ overflowWrap: 'anywhere' }}>{who}</span>
          {list.length
            ? <span style={{ fontSize: 12, color: '#3F7D5A' }}>{t(`已上传 ${list.length} 张`, `${list.length} uploaded`)}</span>
            : <span style={{ fontSize: 12, color: '#9E2B25' }}>{t('待上传', 'Missing')}</span>}
        </div>
      </div>
    );
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={{ fontSize: 12.5, color: S.sub }}>
        {t('双方截图：本会员和对方各至少 1 张，才能标记完成。', 'Screenshots from both sides (at least one each) before this step can be marked done.')}
      </div>
      <input ref={fileRef} type="file" accept="image/*" multiple onChange={onFiles} style={{ display: 'none' }} />
      {!pairs.length ? (
        <div style={{ fontSize: 12.5, color: S.mute }}>{t('这一轮还没有推荐记录。', 'No recommendations in this round yet.')}</div>
      ) : pairs.map((m) => {
        const ok = of(m.id, 'self').length > 0 && of(m.id, 'other').length > 0;
        return (
          <div key={m.id} style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {pairs.length > 1 && (
              <div style={{ fontSize: 12.5, color: S.sub }}>
                {t(`推荐对象：${m.other_name || '—'}`, `With ${m.other_name || '—'}`)}{m.other_offline_id ? ` #${m.other_offline_id}` : ''}
                {ok && <span style={{ color: '#3F7D5A' }}>{t(' · 双方已齐', ' · both sides done')}</span>}
              </div>
            )}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 8 }}>
              {slot(m, 'self')}
              {slot(m, 'other')}
            </div>
          </div>
        );
      })}
    </div>
  );
}
